import Button from '../../components/Button/Button';

const NotFound = () => {
  return (
    <>
      <h1>Sorry this page not found</h1>
      <Button>Not found</Button>
    </>
  );
};

export default NotFound;
